// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63969540","453":"809e0c23","455":"80073188","977":"eeb1d024"}[chunkId] + ".chunk.js";
};